import { Box, Tabs, Tab, Button, CircularProgress, Alert, FormControlLabel, Checkbox } from "@mui/material";


import { MultipleImages, NumberInput } from "../../../../../shared/ui/common/index.js";



import Dropzone from "react-dropzone";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import ReactCrop from "react-image-crop";




/** Presentational section; state and actions remain owned by its parent. */
export default function GalleryUploadForm({ value, handleChange, a11yProps, TabPanel, files, setFiles, loading, uploadDirect, setOpen, setfilename, setPreview, setOnDrag, ondrag, croping, src, filename, crop, setCrop, setCompletedCrop, imgRef, onLoad, previewCanvasRef, setCroping, resizing, setResizing, setQuality, quality, setHeight, height, handleUploadImage, uploadMultiple }) {
  return (
<div>
      <Box
        sx={{ borderBottom: 1, borderColor: "divider" }}
        className="relative z-10"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="  آپلود تکی و تجمیعی عادی" {...a11yProps(0)} />
          <Tab label="  آپلود تکی با امکانات" {...a11yProps(1)} />
          <Tab label="  آپلود جمعی (تغییر فرمت به webp)" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <div className="croper-wrpaer">
        <TabPanel value={value} index={0}>
          <div className="flex w-full max-w-[400px] mt-5 justify-center">
            {" "}
            <MultipleImages files={files} setFiles={setFiles} noMedia />
          </div>
          <div className="flex justify-center mt-5 gap-6">
            <Button
              sx={{ width: "140px" }}
              disabled={loading}
              onClick={uploadDirect}
              variant="contained"
            >
              {loading ? <CircularProgress /> : <> ثبت اطلاعات</>}
            </Button>
            <Button
              onClick={() => setOpen(false)}
              sx={{ width: "140px" }}
              disabled={loading}
              variant="contained"
              color="error"
            >
              انصراف
            </Button>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <>
            {" "}
            <Alert variant="outlined" severity="info">
              تمامی عکس ها جز تایپ svg و gif به webp تبدیل میشوند
            </Alert>
            <div className="flex w-full justify-center">
              <Dropzone
                onDrop={(acceptedFiles) => {
                  setfilename(acceptedFiles[0]);
                  setPreview(acceptedFiles[0]);
                }}
                onDragEnter={() => setOnDrag(true)}
                onDragLeave={() => setOnDrag(false)}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <Box
                      {...getRootProps()}
                      style={{
                        width: "165px",
                        height: "165px",
                        backgroundColor: "#fff",
                        border: ondrag ? "" : "1px solid #ccc",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "36px",
                        flexDirection: "column",
                      }}
                      className={ondrag ? "enterDrag" : ""}
                    >
                      <input {...getInputProps()} />
                      <AddAPhotoOutlinedIcon
                        className=" text-gray-500"
                        fontSize="inherit"
                      />
                      <span className="text-xs text-center text-gray-500 mt-3">
                        فایل بکشید و رها کنید یا کلیک کنید
                      </span>
                    </Box>
                  </section>
                )}
              </Dropzone>
            </div>
            {croping ? (
              <>
                {" "}
                {src && (
                  <>
                    {" "}
                    <div className="img-croper-body my-5">
                      {filename && (
                        <ReactCrop
                          style={{ maxHeight: "100%" }}
                          crop={crop}
                          onChange={(crop, percentCrop) => setCrop(percentCrop)}
                          onComplete={(c) => setCompletedCrop(c)}
                        >
                          {" "}
                          <img
                            ref={imgRef}
                            alt="Crop me"
                            src={src}
                            onLoad={onLoad}
                          />
                        </ReactCrop>
                      )}
                    </div>
                    <canvas
                      style={{ width: 0, height: 0, display: "none" }}
                      ref={previewCanvasRef}
                      width="0"
                      height="0"
                    />
                  </>
                )}
              </>
            ) : (
              <div className="flex items-center justify-center my-3">
                {src && <img src={src} alt="" width={200} height={200} />}
              </div>
            )}
            <div className="flex justify-center mt-5 gap-6">
              <FormControlLabel
                control={<Checkbox checked={croping} />}
                onChange={() => {
                  setCroping(!croping);
                }}
                label={<h2 className=" text-[0.78rem]"> استفاده از کراپر</h2>}
              />
              <FormControlLabel
                control={<Checkbox checked={resizing} />}
                onChange={() => {
                  setResizing(!resizing);
                }}
                label={<h2 className=" text-[0.78rem]"> کم کردن حجم عکس </h2>}
              />
            </div>
            {resizing ? (
              <div className="grid md:grid-cols-2 gap-7 mt-7">
                {" "}
                <NumberInput
                  label=" درصد کیفیت عکس"
                  change={setQuality}
                  value={quality}
                />{" "}
                <NumberInput
                  label="  حداکثر ارتفاع"
                  change={setHeight}
                  value={height}
                />
              </div>
            ) : (
              <></>
            )}
            <div className="flex justify-center mt-5 gap-6">
              <Button
                sx={{ width: "140px" }}
                disabled={loading}
                onClick={handleUploadImage}
                variant="contained"
              >
                {loading ? <CircularProgress /> : <> ثبت اطلاعات</>}
              </Button>
              <Button
                sx={{ width: "140px" }}
                disabled={loading}
                variant="contained"
                color="error"
                onClick={() => setOpen(false)}
              >
                انصراف
              </Button>
            </div>
          </>
        </TabPanel>
        <TabPanel value={value} index={2}>
        <Alert variant="outlined" severity="info">
              تمامی عکس ها جز تایپ svg و gif به webp تبدیل میشوند
            </Alert>
          <div className="flex w-full max-w-[400px] justify-center">
            {" "}
            <MultipleImages files={files} setFiles={setFiles} noMedia />
          </div>

          <div className="flex justify-center mt-5 gap-6">
            <Button
              sx={{ width: "140px" }}
              disabled={loading}
              onClick={uploadMultiple}
              variant="contained"
            >
              {loading ? <CircularProgress /> : <> ثبت اطلاعات</>}
            </Button>
            <Button
              onClick={() => setOpen(false)}
              sx={{ width: "140px" }}
              disabled={loading}
              variant="contained"
              color="error"
            >
              انصراف
            </Button>
          </div>
        </TabPanel>
      </div>
    </div>
  );
}
